"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@qubic-js/core");
const createCacheMiddleware = (bridge) => {
    let cacheAddresses = [];
    let cacheNetwork = '';
    bridge.on(core_1.BridgeEvent.accountsChanged, addresses => {
        cacheAddresses = addresses;
    });
    bridge.on(core_1.BridgeEvent.chainChanged, chainId => {
        cacheNetwork = chainId;
    });
    bridge.on(core_1.BridgeEvent.clear, () => {
        cacheAddresses = [];
        cacheNetwork = '';
    });
    return (req, res, next, end) => {
        if (req.method === 'eth_accounts' && cacheAddresses.length > 0) {
            res.result = cacheAddresses;
            end();
            return;
        }
        if (req.method === 'eth_chainId' && cacheNetwork) {
            res.result = cacheNetwork;
            end();
            return;
        }
        next();
    };
};
exports.default = createCacheMiddleware;
